
















































































































































































































































import Vue from 'vue'
import { ProjectDetail } from '@/model/project/ProjectDetail'
import moment from 'moment'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxColumnChooser,
  DxSorting,
  DxFilterRow,
  DxGroupPanel, DxGrouping, DxStateStoring
} from 'devextreme-vue/data-grid'
import {
  DELETE_PROJECT_DETAIL,
  EDIT_PROJECT_DETAIL,
  FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST,
  GET_PROJECT_DETAIL_LOOKUPS
} from '@/store/action-types'
import { Currency } from '@/model/planning/Currency'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { KeyActionEnum, SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import TextLanguagesDialog from '@/components/project/TextLanguagesDialog.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import {
  CodeList,
  Einheit,
  GetProjectDetailLookupsResponse,
  ProjectDetailText, Rabbat,
  ResponseBase, Steuer
} from '@/types/service-response'
import { DeleteProjectDetailPayload, EditProjectDetailPayload, UpdateProjectDetailText } from '@/types/payload'
import { TranslateResult } from 'vue-i18n'
import CreateProjectDetailAssistant from '@/components/project/CreateProjectDetailAssistant.vue'
import CreateProjectDetailFastDialog from '@/components/project/CreateProjectDetailFastDialog.vue'
import ProjectProcessGantt from '@/components/project/ProjectProcessGantt.vue'
import NumberField from '@/components/NumberField.vue'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'
import ProjectPartsList from '@/components/project/ProjectPartsList.vue'
import ToolsTreeMenu from '@/components/tools/ToolsTreeMenu.vue'
import * as securityService from '@/services/security-service'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  tableHeight: string
  ganttHeight: number
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  activeTab1: number
  activeTab2: number
  detailIndex: number
  detailNumber: number
  selectedDetailIndex: number | undefined
  selectedDetail: ProjectDetail | undefined
  formIsValid: boolean
  art: string | undefined //number | undefined
  artS: number | undefined
  artList: CodeList[]
  menge: number
  einheit: string | undefined //number | undefined
  einheitS: number | undefined
  einheitList: Einheit[]
  preis: number | null
  pe: any
  rabatt: string | undefined //number | undefined
  rabattS: number | undefined
  rabattList: Rabbat []
  steuer: string | undefined //number | undefined
  steuerS: number | undefined
  steuerList: Steuer []
  wahrung: number | undefined
  wahrungList: Currency[]
  kommission: string | undefined //number | undefined
  kommissionList: any[]
  kommissionsNummer: string
  kommissionsBezeichnung: string
  produktBezeichnung: string
  displayText: string
  menu1: boolean
  selectRules: any[]
  dateRules: any[]
  referenzTerminFormatted: string | null
  referenzTermin: string | null
  summe: number
  mengeErfasst: number
  text: string
  projectDetailText: ProjectDetailText[]
  klText: string

  isEdit: boolean
  isSaveInProgress: boolean
  showWarningDialog: boolean
  showTextLanguagesDialog: boolean
  warningMessage: string

  showCreateProjectDetailAssistant: boolean
  showCreateProjectDetailFastDialog: boolean
  newDetailId: number | undefined

  gesperrt: boolean
  gesperrtVonName: string
  seitenumbruch: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'ProjectDetailForm',

  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxSorting,
    DxFilterRow,
    DxGroupPanel,
    DxGrouping,
    DxScrolling,
    DxStateStoring,
    WarningDialog,
    ProgressCircular,
    TextLanguagesDialog,
    CreateProjectDetailAssistant,
    CreateProjectDetailFastDialog,
    ProjectProcessGantt,
    NumberField,
    ProjectPartsList,
    ToolsTreeMenu
  },

  props: {
    projectId: Number,
    projectDetail: Array as () => ProjectDetail[],
    disabled: Boolean,
    height: String
  },

  data (): ComponentData {
    return {
      tableHeight: 'height: 200px',
      ganttHeight: 200,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      activeTab1: 1,
      activeTab2: 0,
      detailIndex: 0,
      detailNumber: 0,
      selectedDetailIndex: undefined,
      selectedDetail: undefined,
      formIsValid: false,
      art: undefined,
      artS: undefined,
      artList: [],
      menge: 0.000,
      einheit: undefined,
      einheitS: undefined,
      einheitList: [],
      preis: 0.00,
      pe: '',
      rabatt: undefined,
      rabattS: undefined,
      rabattList: [],
      steuer: undefined,
      steuerS: undefined,
      steuerList: [],
      wahrung: undefined,
      wahrungList: [],
      kommission: undefined,
      kommissionList: [],
      kommissionsNummer: '',
      kommissionsBezeichnung: '',
      produktBezeichnung: '',
      displayText: '',
      menu1: false,
      selectRules: [(value: any): boolean | string => !!value || ''],
      dateRules: [
        (value: string) => {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          return value ? value.length >= 1 ? pattern.test(value) || this.$t('errors.wrongDate').toString() : true : true
        },

        (value: string) => {
          return !!value
        },
      ],
      referenzTerminFormatted: '',
      referenzTermin: '',
      summe: 0,
      mengeErfasst: 0,
      text: '',
      projectDetailText: [],
      klText: '',

      isEdit: false,
      isSaveInProgress: false,
      showWarningDialog: false,
      showTextLanguagesDialog: false,
      warningMessage: '',

      showCreateProjectDetailAssistant: false,
      showCreateProjectDetailFastDialog: false,
      newDetailId: undefined,

      gesperrt: false,
      gesperrtVonName: '',
      seitenumbruch: false,

      keyActions: []
    }
  },

  watch: {
    projectId (newVal: number): void {
      if(newVal) {
        this.activeTab1 = 1
        this.isEdit = false
      }
    },

    activeTab1 (newVal: number): void {
      if(this.$route.path === '/project') {
        let data: any = this.getRouteData()
        data.detailTab = newVal
        this.$router.push({ name: 'Project', query: { data: JSON.stringify(data) } })
      }
        if (newVal === 1) {
          //@ts-ignore
          setTimeout(() => { this.$refs.dataGrid.instance.refresh() }, 0)
          setTimeout(() => { this.onResize() }, 0)
        }
    },

    projectDetail(newVal: ProjectDetail[]): void {
      if(newVal) {
        if(this.newDetailId) {
          const foundDetail: ProjectDetail | undefined = this.projectDetail.find((item: ProjectDetail) => item.ID === this.newDetailId)
          this.newDetailId = undefined
          let indexOfNewDetail: number | undefined = undefined
          if(foundDetail) {
            indexOfNewDetail = this.projectDetail.indexOf(foundDetail)
          }
          this.detailIndex = indexOfNewDetail && indexOfNewDetail >= 0 ? indexOfNewDetail : this.selectedDetailIndex ? this.selectedDetailIndex : 0
          this.selectedDetailIndex = undefined
          this.setValues()
        } else if(this.selectedDetailIndex) {
          this.detailIndex = this.selectedDetailIndex
          this.selectedDetailIndex = undefined
          this.setValues()
        } else {
          this.detailIndex = 0
          this.setValues()
        }
      }
    },

    detailIndex(newVal: number): void {
      if(newVal !== null || newVal !== undefined) {
        if(this.$route.path === '/project') {
          let data: any = this.getRouteData()
          data.detailIndex = newVal
          this.$router.push({ name: 'Project', query: { data: JSON.stringify(data) } })
        }
        this.setValues()
      }
    },

    text(newVal: string): void {
      this.projectDetailText.forEach((item: ProjectDetailText) => {
        if(item.Sprache === this.selectedLanguageId) {
          item.Text = newVal
        }
      })
    },

    referenzTerminFormatted (newVal: string | null): void {
      if(newVal) {
        this.referenzTermin = moment(newVal, 'DD.MM.YYYY').isValid() ? moment(newVal, 'DD.MM.YYYY').format('YYYY-MM-DD') : ''
      } else {
        this.referenzTermin = ''
      }
    },
  },

  computed: {
    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    isMengeDisabled (): boolean {
      return this.artS === 3 || this.artS === 4 || this.artS === 5
    },

    isPriceDisabled (): boolean {
      return this.artS === 3 || this.artS === 4 || this.artS === 5
    },

    isSelectsDisabled (): boolean {
      return this.artS === 3 || this.artS === 4 || this.artS === 5
    },

    showInsertButton (): boolean {
      return securityService.isVisible(SecurityArea.Projects, SecurityComponent.IconInsert)
    },

    isDisabledInsertButton (): boolean {
      return securityService.isDisabled(SecurityArea.Projects, SecurityComponent.IconInsert)
    },

    showUpdateButton (): boolean {
      return securityService.isVisible(SecurityArea.Projects, SecurityComponent.IconUpdate)
    },

    isDisabledUpdateButton (): boolean {
      return securityService.isDisabled(SecurityArea.Projects, SecurityComponent.IconUpdate)
    },

    showDeleteButton (): boolean {
      return securityService.isVisible(SecurityArea.Projects, SecurityComponent.IconDelete)
    },

    isDisabledDeleteButton (): boolean {
      return securityService.isDisabled(SecurityArea.Projects, SecurityComponent.IconDelete)
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return !this.disabled && this.showInsertButton && !this.isDisabledInsertButton
      } else if(action instanceof Edit) {
        return !(!this.selectedDetail || this.disabled || (this.selectedDetail && this.selectedDetail.BereitsGebucht)) && this.showUpdateButton && !this.isDisabledUpdateButton
      } else if(action instanceof Delete) {
        return !(!this.selectedDetail || this.disabled || (this.selectedDetail && this.selectedDetail.BereitsGebucht)) && this.showDeleteButton && !this.isDisabledDeleteButton
      } else {
        return false
      }
    },

    formatNumber(value: number | null, digital: number, art: number): any {
      if(value !== null && art !== 3 && art !== 4) {
        return new Intl.NumberFormat(navigator && navigator.language ? navigator.language : "de-CH", {
          style: "decimal",
          minimumFractionDigits: digital,
          maximumFractionDigits: digital
        }).format(value)
      } else {
        return ''
      }
    },

    onMengeChange (): void {
      if(this.menge == null) {
        this.menge = 0.000
      }
    },

    onPreisChange (): void {
      if(this.preis == null) {
        this.preis = 0.00
      }
    },

    onResize (): void {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = 710
          if((vh - height) > 200) {
            this.tableHeight = `height: calc(${vh}px - ${height}px)`
            this.ganttHeight = vh - height
          } else {
            this.tableHeight = 'height: 200px'
            this.ganttHeight = 200
          }
        } else {
          this.tableHeight = 'height: 200px'
          this.ganttHeight = 200
        }
    },

    onReferenzTerminChange (date: string): void {
      this.referenzTerminFormatted = moment(date).format('DD.MM.YYYY')
    },

    onBlurProject (): void {
      this.referenzTerminFormatted = this.referenzTermin && moment(this.referenzTermin).isValid() ? moment(this.referenzTermin).format('DD.MM.YYYY') : ''
      setTimeout(() => {
        if(this.menu1) {
          this.menu1 = false
        }
      }, 100)
    },

    tabChange (item: number): void {
      if(item === 1) {
        this.onCancelClick()
      }
    },

    onAddProjectDetailClick (): void {
      this.isEdit = false
      this.showCreateProjectDetailAssistant = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddProjectDetailClick()
    },

    onCreatedProjectDetail (projectDetailID: number): void {
      this.activeTab1 = 0
      this.newDetailId = projectDetailID
      this.showCreateProjectDetailAssistant = false
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
      this.$emit('createdDetail')
    },

    onCloseCreateProjectDetailClick (): void {
      this.showCreateProjectDetailAssistant = false
    },

    onAddProjectDetailFastClick (): void {
      this.isEdit = false
      this.showCreateProjectDetailFastDialog = true
    },

    onCreatedProjectDetailFast (lastProjectDetailID: number): void {
      this.activeTab1 = 0
      this.newDetailId = lastProjectDetailID
      this.showCreateProjectDetailFastDialog = false
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true
      this.$emit('createdDetail')
    },

    onCloseCreateProjectDetailFastClick (): void {
      this.showCreateProjectDetailFastDialog = false
    },

    onEditProjectDetailClick (): void {
      this.activeTab1 = 0
      this.isEdit = true
      setTimeout(() => {
        const focusedField: any = this.$refs['focusedField']
        if (focusedField) {
          focusedField.focus()
        }
      }, 100)
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditProjectDetailClick()
    },

    onDeleteProjectDetailClick (): void {
      this.isEdit = false
      this.warningMessage = this.$t('project.deleteProjectDetailMessage').toString()
      this.showWarningDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteProjectDetailClick()
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    async onWarningDialogSave (): Promise<void> {
      this.showWarningDialog = false
      if(this.selectedDetail && this.selectedDetail.ID) {
        const payload: DeleteProjectDetailPayload = {
          ID: this.selectedDetail.ID,
          LanguageId: this.selectedLanguageId
        }

        try {
          this.loading = true
          const response: ResponseBase = await this.$store.dispatch(DELETE_PROJECT_DETAIL, payload)
          this.loading = false
          if (!response.IsError) {
            this.messageSnackbar = this.$t('success.dataHaveBeenDeleted')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.$emit('deletedDetail', this.selectedDetail)
            this.selectedDetail = undefined
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.loading = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onProjectDetailBeforeClick (): void {
      this.isEdit = false
      this.detailIndex -= 1
      this.detailNumber = this.projectDetail[this.detailIndex].Zeile
      this.selectedDetail = this.projectDetail[this.detailIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.projectDetail[this.detailIndex].ID])
    },

    onProjectDetailAfterClick (): void {
      this.isEdit = false
      this.detailIndex += 1
      this.detailNumber = this.projectDetail[this.detailIndex].Zeile
      this.selectedDetail = this.projectDetail[this.detailIndex]
      //@ts-ignore
      this.$refs.dataGrid.instance.selectRows([this.projectDetail[this.detailIndex].ID])
    },

    onRowClick (data: any): void {
      const foundProjectDetail: ProjectDetail | undefined = this.projectDetail.find((item: ProjectDetail) => item.ID === data.data.ID)
      if(foundProjectDetail) {
        this.detailIndex = this.projectDetail.indexOf(foundProjectDetail)
        this.detailNumber = foundProjectDetail.Zeile
        this.selectedDetail = foundProjectDetail
      }
    },

    onCancelClick (): void {
      this.isEdit = false
      this.setValues()
    },

    onSaveButtonClick (): void {
      this.editProjectDetail()
    },

    async editProjectDetail (): Promise<void> {
      const form: any = this.$refs['form']
      if(this.selectedDetail && this.selectedDetail.ID && this.formIsValid && form.validate()) {
        const texts: UpdateProjectDetailText[] = this.projectDetailText.map((item: ProjectDetailText) => {
          return {
            ProjectDetailId: this.selectedDetail!.ID,
            LanguageId: item.Sprache,
            Text: item.Text,
            TextArt: item.TextArt
          }
        })

        const payload: EditProjectDetailPayload = {
          ID: this.selectedDetail.ID,
          Menge: this.isMengeDisabled ? 0 : this.menge,
          LanguageId: this.selectedLanguageId,
          Position: this.detailNumber,
          Art: this.artS!,
          Einheit: this.isSelectsDisabled ? null : this.einheitS ? this.einheitS : null,
          Preis: this.isPriceDisabled ? 0 : this.preis,
          Rabbat: this.isSelectsDisabled ? null : this.rabattS ? this.rabattS : null,
          Steuer: this.isSelectsDisabled ? null : this.steuerS ? this.steuerS : null,
          ReferenzTermin: this.referenzTermin!,
          Texts: texts,
          Gesperrt: [{ProjectDetailId: this.selectedDetail.ID, Gesperrt: this.gesperrt}],
          Seitenumbruch: [{ProjectDetailId: this.selectedDetail.ID, Seitenumbruch: this.seitenumbruch}]
        }

        try {
          this.isSaveInProgress = true
          const response: ResponseBase = await this.$store.dispatch(EDIT_PROJECT_DETAIL, payload)
          this.isSaveInProgress = false
          if (!response.IsError) {
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
            this.snackbarState = SnackbarStateEnum.Success
            this.showSnackbar = true
            this.isEdit = false
            this.selectedDetailIndex = this.detailIndex
            this.$emit('updatedDetail')
          } else {
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
            this.snackbarState = SnackbarStateEnum.Error
            this.showSnackbar = true
          }
        } catch {
          this.isSaveInProgress = false
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      }
    },

    onTextLanguagesClick (): void {
      this.showTextLanguagesDialog = true
    },

    onKlTextLanguagesClick (): void {
      //this.showTextLanguagesDialog = true
    },

    onTextLanguagesDialogSave (payload: ProjectDetailText[]): void {
      this.projectDetailText = payload
      const foundText: ProjectDetailText | undefined = this.projectDetailText.find((item: ProjectDetailText) => item.Sprache === this.selectedLanguageId)
      this.text = foundText && foundText.Text ? foundText.Text : ''
      this.onTextLanguagesDialogClose()
    },

    onTextLanguagesDialogClose (): void {
      this.showTextLanguagesDialog = false
    },

    setValues (): void {
      if(this.projectDetail[this.detailIndex]) {
        this.fetchLookups()
        this.detailNumber = this.projectDetail[this.detailIndex].Zeile
        this.selectedDetail = this.projectDetail[this.detailIndex]
        this.art = this.projectDetail[this.detailIndex].ArtBezeichnung
        this.artS = this.projectDetail[this.detailIndex].Art
        this.menge = this.projectDetail[this.detailIndex].Menge !== null ? parseFloat(this.projectDetail[this.detailIndex].Menge) : 0.000
        //this.einheit = this.projectDetail[this.detailIndex].EinheitCode
        this.einheitS = this.projectDetail[this.detailIndex].Einheit
        this.preis = this.projectDetail[this.detailIndex].Preis !== null ? parseFloat(this.projectDetail[this.detailIndex].Preis) : 0.00
        this.pe = this.projectDetail[this.detailIndex].Preiseinheit
        //this.rabatt = this.projectDetail[this.detailIndex].RabattCode
        this.rabattS = this.projectDetail[this.detailIndex].Rabatt
        //this.steuer = this.projectDetail[this.detailIndex].Steuersatz
        this.steuerS = this.projectDetail[this.detailIndex].Steuer
        this.wahrung = this.projectDetail[this.detailIndex].Waehrung
        this.kommission = this.projectDetail[this.detailIndex].LagerCode
        this.kommissionsNummer = this.projectDetail[this.detailIndex].KommissionsNummer
        this.kommissionsBezeichnung = this.projectDetail[this.detailIndex].KommissionsBezeichnung
        this.produktBezeichnung = this.projectDetail[this.detailIndex].ProduktBezeichnung
        this.displayText = this.projectDetail[this.detailIndex].DisplayText
        this.referenzTerminFormatted = moment(this.projectDetail[this.detailIndex].ReferenzTermin).format('DD.MM.YYYY')
        this.referenzTermin = moment(this.projectDetail[this.detailIndex].ReferenzTermin).format('YYYY-MM-DD')
        this.summe = this.projectDetail[this.detailIndex].NettoExklusive !== null ? parseFloat(this.projectDetail[this.detailIndex].NettoExklusive) : 0.00
        this.mengeErfasst = this.projectDetail[this.detailIndex].MengeErfasst !== null ? parseFloat(this.projectDetail[this.detailIndex].MengeErfasst) : 0.000
        //this.text = this.projectDetail[this.detailIndex].Text
        this.klText = this.projectDetail[this.detailIndex].KLText
        this.gesperrt = this.projectDetail[this.detailIndex].Gesperrt
        this.gesperrtVonName = this.projectDetail[this.detailIndex].GesperrtVonNameK
        this.seitenumbruch = this.projectDetail[this.detailIndex].Seitenumbruch
        //@ts-ignore
        setTimeout(() => {this.$refs.dataGrid.instance.selectRows([this.projectDetail[this.detailIndex].ID])}, 200)
      } else {
        this.detailNumber = 0
        this.selectedDetail = undefined
        this.art = undefined
        this.menge = 0.000
        this.einheit = undefined
        this.preis = 0.00
        this.pe = ''
        this.rabatt = undefined
        this.steuer = undefined
        this.wahrung = undefined
        this.kommission = undefined
        this.produktBezeichnung = ''
        this.displayText = ''
        this.referenzTerminFormatted = ''
        this.referenzTermin = ''
        this.summe = 0.00
        this.mengeErfasst = 0.000
        this.text = ''
        this.klText = ''
        this.gesperrt = false
        this.gesperrtVonName = ''
        this.seitenumbruch = false
      }
    },

    async fetchData (): Promise<void> {
      this.wahrungList = await this.$store.dispatch(FETCH_ADDITIONAL_SERVICES_CURRENCY_LIST)
    },

    async fetchLookups (): Promise<void> {
      const response: GetProjectDetailLookupsResponse = await this.$store.dispatch(GET_PROJECT_DETAIL_LOOKUPS, this.projectDetail[this.detailIndex].ID)

      if(!response.IsError) {
        this.artList = response.Art ? response.Art : []
        this.einheitList = response.Einheit ? response.Einheit : []
        this.rabattList = response.Rabbat ? response.Rabbat : []
        this.steuerList = response.Steuer ? response.Steuer : []
        this.projectDetailText = response.Text ? response.Text : []

        const foundEinheit: Einheit | undefined = this.einheitList.find((item: Einheit) => item.ID === this.einheitS)
        const foundRabatt: Rabbat | undefined = this.rabattList.find((item: Rabbat) => item.ID === this.rabattS)
        const foundSteuer: Steuer | undefined = this.steuerList.find((item: Steuer) => item.ID === this.steuerS)
        const foundText: ProjectDetailText | undefined = this.projectDetailText.find((item: ProjectDetailText) => item.Sprache === this.selectedLanguageId)

        this.einheit = foundEinheit && foundEinheit.Bezeichnung ? foundEinheit.Bezeichnung : ''
        this.rabatt = foundRabatt && foundRabatt.Bezeichnung ? foundRabatt.Bezeichnung : ''
        this.steuer = foundSteuer && foundSteuer.Bezeichnung ? foundSteuer.Bezeichnung : ''
        this.text = foundText && foundText.Text ? foundText.Text : ''
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/project') {
        this.detailIndex = data && data.detailIndex ? data.detailIndex : 0
        this.activeTab1 = data && data.detailTab !== undefined ? data.detailTab : 1
      }
    }
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.setDataFromRoute()
    if(this.projectDetail) {
      this.setValues()
    }
    this.fetchData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
